import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {
    const { pathname, hash } = useLocation();

    useEffect(() => {
        // If there is a hash (like #features), let our other logic handle it.
        // Otherwise, scroll right to the top left of the page.
        if (!hash) {
            window.scrollTo(0, 0);
        }
    }, [pathname, hash]); // Trigger this every time the route or hash changes

    return null; // This component doesn't render any visual UI
};

export default ScrollToTop;